"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTypeEnum = void 0;
var FieldTypeEnum;
(function (FieldTypeEnum) {
    FieldTypeEnum["Contact"] = "Contact";
    FieldTypeEnum["Conversation"] = "Conversation";
    FieldTypeEnum["FormSubmission"] = "FormSubmission";
    FieldTypeEnum["Chat"] = "Chat";
})(FieldTypeEnum = exports.FieldTypeEnum || (exports.FieldTypeEnum = {}));
